// @flow

import './MetadataVideoOverlay.css';

import * as React from 'react';
import VideoController from './VideoController';
import { KeyCode } from '../util/Constants';

type Props = {
  controller: VideoController,
  text: string,
  onChangeText: Function
};

type State = {
  editMode: boolean,
  value: string,
  style: Object
};

export default class MetadataVideoOverlay extends React.Component<Props, State> {
  _node: ?HTMLDivElement;
  _inputNode: ?HTMLTextAreaElement;

  state = {
    editMode: false,
    value: '',
    style: {}
  };

  onClick = () => {
    if (this.state.editMode) {
      return;
    }

    this.props.controller.playing = false;
    document.addEventListener('click', this.onDocumentClick, true);

    const rect = this._node ? this._node.getBoundingClientRect() : {};
    const style = {
      width: rect.width,
      height: rect.height
    };

    this.setState({ editMode: true, value: this.props.text.trim(), style });
  };

  onDocumentClick = (e: MouseEvent) => {
    if (e.target !== this._inputNode) {
      document.removeEventListener('click', this.onDocumentClick, true);
      this.props.onChangeText(this.state.value);
      this.setState({ editMode: false });
    }
  };

  onChange = (e: Event) => {
    this.setState({ value: e.target.value });
  };

  onKeyDown = (e: KeyboardEvent) => {
    if (e.keyCode === KeyCode.ESCAPE) {
      document.removeEventListener('click', this.onDocumentClick, true);
      this.setState({ editMode: false });
    }
  };

  render() {
    const { text } = this.props;
    const { editMode, value, style } = this.state;

    return editMode ? (
      <textarea
        name="MetadataVideoOverlay"
        value={value}
        onChange={this.onChange}
        onKeyDown={this.onKeyDown}
        style={style}
        ref={(node) => (this._inputNode = node)}
        autoFocus
      />
    ) : (
      <div name="MetadataVideoOverlay" onClick={this.onClick} ref={(node) => (this._node = node)}>
        {text}
      </div>
    );
  }
}
